import React, { useRef, useState, useEffect } from 'react';
import { useParams } from "react-router";
import { Skeleton, Empty, Button, message, Modal, List } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { IMAGES, UPLOADS, FILES } from '../../../../params';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import 'swiper/swiper.min.css';
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
import { TbReload } from "react-icons/tb";
SwiperCore.use([Autoplay, Navigation, Pagination]);

export const Item = props => {
    
    const dispatch = useDispatch();
    const app_global = useSelector(state => state.app_global);
    
    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)

    const [activeModal, setActiveModal] = useState("");

    const [page, setPage] = useState(1);
    const [page2, setPage2] = useState(1);
    const [paginationSize, setPaginationSize] = useState(6);

    const params = useParams();

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    async function component_start() {
        
    }

    return (
        <>
            {
                app_global.loading ?
                <section className='container shadow default_padding marginTop'>
                    <div className='content'>
                        <Skeleton active />
                    </div>
                </section>
            :
                <>
                    <Modal mask centered className="modal_portal" key="m1" width={1600} title="Как правильно питаться?" open={activeModal === 'diary'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                        <div className='header'>
                            <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                            </svg>
                            <h2>Дневник самоконтроля</h2>
                        </div>
                        <p style={{display:'flex',justifyContent:'center',textAlign:'center',marginBottom:50}}>
                            <img src={`${IMAGES}/banners/diary.jpg`} style={{width:'100%',objectFit:'contain'}} />
                        </p>
                        <div className="fcenter">
                            <a href={`${FILES}/pdf/diary.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                        </div>
                    </Modal>
                    <section className='container_full --hls_item_9'>
                        <section className='top'>
                            <section className='container shadow default_padding'>
                                <h1>Дневник контроля сна</h1>
                            </section>
                        </section>
                        <section className='body'>
                            <section className='container shadow default_padding'>
                                <section className='left'>
                                    <p className='title'>Рекомендуем ознакомиться</p>
                                    <p className='excerpt'>Прочитав статьи вы сможете качественно улучшить текущее состояние вашего здоровья.</p>
                                    <div className='slider_pc'>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_00.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Здоровый образ жизни</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_01.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Правильное питание</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_02.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Физическая активность</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className='slider_mob'>
                                        <Swiper
                                            loop
                                            spaceBetween={12}
                                            slidesPerView={1.5}
                                            pagination={{
                                                type: "progressbar",
                                            }}
                                            navigation={{
                                                prevEl: navigationPrevRef.current,
                                                nextEl: navigationNextRef.current,
                                            }}
                                            onBeforeInit={(swiper) => {
                                                swiper.params.navigation.prevEl = navigationPrevRef.current;
                                                swiper.params.navigation.nextEl = navigationNextRef.current;
                                            }}
                                            breakpoints={{
                                                992: {
                                                    slidesPerView: 2.75,
                                                },
                                                991: {
                                                    slidesPerView: 2,
                                                },
                                                700: {
                                                    slidesPerView: 1.5,
                                                },
                                            }}
                                        >
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_00.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Здоровый образ жизни</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_01.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Правильное питание</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_02.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Физическая активность</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                        </Swiper>
                                    </div>
                                </section>
                                <section className='right'>
                                    <div className='content'>
                                        <div className='header'>
                                            <div className='posts_image_big'>
                                                <img src={`${IMAGES}/banners/hls_image_04_03_01.jpeg`} />
                                            </div>
                                        </div>

                                        <div className='body'>
                                            <div className='text_content'>
                                                <p>Сон — это физиологический процесс, который важен для здоровья и благополучия человека. Сон отвечает за восстановление организма, поддержание иммунной системы, улучшение психического здоровья, регулирование аппетита и метаболизма, улучшение качества жизни в целом. </p>
                                                <p>Таким образом, сон является важным фактором, который может оказывать влияние на многие аспекты жизни человека, включая физическое и психическое здоровье, работоспособность и качество жизни.</p>
                                                <p><strong>Есть несколько способов, которые могут помочь улучшить сон:</strong></p>
                                                <ul>
                                                    <li><none /><strong>Соблюдение регулярного расписания:</strong> Важно ложиться и просыпаться каждый день в одно и то же время. Это помогает установить внутренний биологический ритм организма, который в свою очередь может улучшить качество сна</li>
                                                    <li><none /><strong>Создание комфортной атмосферы в спальне:</strong> В спальне должно быть тихо, прохладно и темно. Некоторые люди предпочитают использовать затемняющие шторы или маски для сна. Удобный матрас и подушка также могут сделать сон более комфортным</li>
                                                    <li><none /><strong>Избегание кофеина и алкоголя:</strong> Кофеин и алкоголь могут мешать засыпанию и качеству сна. Лучше не употреблять их в течение нескольких часов перед сном</li>
                                                    <li><none /><strong>Регулярная физическая активность:</strong> Физическая активность может улучшить качество сна, но лучше заниматься не позднее чем за несколько часов до сна</li>
                                                    <li><none /><strong>Расслабляющие практики перед сном:</strong> Расслабляющие практики, такие как медитация, глубокое дыхание, йога или чтение книги, могут помочь снять стресс и расслабиться перед сном</li>
                                                    <li><none /><strong>Избегание употребления пищи перед сном:</strong> Лучше не употреблять тяжелую пищу или еду, которая может вызвать переваривание, за пару часов до сна</li>
                                                    <li><none /><strong>Избегание использования электронных устройств перед сном:</strong> Экраны компьютера, телефона или планшета могут снижать уровень мелатонина, гормона, который регулирует сон. Лучше не использовать эти устройства перед сном</li>
                                                    <li><none /><strong>Обращение к специалисту:</strong> Если проблемы со сном продолжаются, обратитесь к специалисту. Врач или специалист по сну могут помочь выявить проблемы со сном и предложить подходящее лечение</li>
                                                </ul>
                                                <p>Улучшение качества сна может помочь улучшить качество жизни, улучшить работоспособность и повысить настроение.</p>
                                            </div>
                                            <section className='container shadow default_padding next'>
                                                <div className='next_container' onClick={() => setActiveModal('diary')}>
                                                    <div className='content full'>
                                                        <div className='list visible'>
                                                            <div className='item image_item'>
                                                                <div className='rotate' style={{background: `url(${IMAGES}/banners/hls_image_04_03_02.jpg)`}}>

                                                                </div>
                                                            </div>
                                                            <div className='item text_item'>
                                                                <div className='rotate'>
                                                                    <p>Дневник самоконтроля</p>
                                                                    <span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                            <div className="fcenter custom_bg_text" style={{marginTop:50}}>
                                                <Link to={`/specializations/`} exact={ true } onClick={() => scroll.scrollToTop()} className="submit_mini_white" >Узнайте, как улучшить свой образ жизни</Link>
                                                <Link to={`/hls/surveys/`} exact={ true } onClick={() => scroll.scrollToTop()} className="submit_mini" >Пройдите тест и проверьте своё здоровье</Link>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </section>
                        </section>
                    </section>
                </>
            }
        </>
    );
};